import dataProvider from 'ra-data-json-server';

export default (url) => dataProvider(url);
